import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { MenuNode } from "../../api/generated";
import { SET_SELECTED_MENU } from "../../store/actions/configurationActions";
import { getMenuStructure } from "../../store/sagas/selectors";

const MobileMenus = styled.div`
    overflow: auto;
`;

const MobileMenuButton = styled.div`
    padding: 16px;
    margin: 18px 0;
    background: white;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    color: #333333;
    &:hover {
        background: rgba(229, 229, 229, 0.8);
    }
    &:active {
        background: rgba(212, 212, 212, 0.9);
    }
`;

export const MobileMainMenu = () => {
    const dispatch = useDispatch();
    const menus = useSelector(getMenuStructure);

    const handleMenuClick = (menu: MenuNode) => {
        dispatch({ type: SET_SELECTED_MENU, selectedMenu: menu.id });
    };
    return (
        <MobileMenus>
            {menus.map(menu => {
                return (
                    <MobileMenuButton key={menu.id} onClick={() => handleMenuClick(menu)}>
                        {menu.displayText || menu.id}
                    </MobileMenuButton>
                );
            })}
        </MobileMenus>
    );
};
